import { RouteRecordRaw } from 'vue-router';
import { RouteMetaType, ExtendedRouteMetaType } from '@router/routes/types';
import { ENTRY_POINTS } from '@constants/entry-points';

type AuthRouteMetaType = RouteMetaType & {
  requiresAuth: false;
  requiresTenant: false;
  requiresTenantAdmin: false;
  requiresEnterpriseLicense: false;
};

const META_DEFAULT: AuthRouteMetaType = Object.freeze({
  requiresAuth: false,
  requiresTenant: false,
  requiresTenantAdmin: false,
  requiresEnterpriseLicense: false,
  redirectOnError: ENTRY_POINTS.PATH.UNAUTHORIZED(),
});

const getMeta = (
  extendedMeta: ExtendedRouteMetaType<AuthRouteMetaType> = {},
): AuthRouteMetaType => ({ ...META_DEFAULT, ...extendedMeta });

const routes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    name: 'auth-home',
    component: () => import('@views/auth/AuthRootView.vue'),
    redirect: ENTRY_POINTS.PATH.SIGNUP_TOP(),
    meta: getMeta(),
    children: [
      {
        path: 'verification/email/:context',
        name: ENTRY_POINTS.PATH.EMAIL_VERIFICATION().name,
        component: () => import('@views/auth/EmailVerificationView.vue'),
        meta: getMeta({ title: 'Verify Email' }),
      } as RouteRecordRaw,
      {
        path: 'login',
        name: 'login',
        component: () => import('@views/auth/LoginView.vue'),
        meta: getMeta({ title: 'Login' }),
      } as RouteRecordRaw,
      {
        path: 'signup',
        name: 'signup',
        component: () => import('@views/auth/SignupView.vue'),
        meta: getMeta({ title: 'Signup' }),
      } as RouteRecordRaw,
      {
        path: 'reset/password',
        name: 'password-reset',
        component: () => import('@views/auth/PasswordResetView.vue'),
        meta: getMeta({ title: 'Password Reset' }),
      } as RouteRecordRaw,
      {
        path: 'sso/callback/',
        name: 'sso-callback',
        component: () => import('@views/auth/SsoCallbackView.vue'),
        meta: getMeta({ title: 'Single Sign-On' }),
      } as RouteRecordRaw,
      {
        path: 'error/code/:context',
        name: ENTRY_POINTS.PATH.AUTH_CODE_ERROR().name,
        component: () => import('@views/auth/CodeErrorView.vue'),
        meta: getMeta({ title: 'Link Expired' }),
      },
    ],
  },
];

export default routes;
